var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 39.2722C9.18391 35.633 6.625 30.3443 6.625 24.458C6.625 13.4813 15.5233 4.58301 26.5 4.58301C37.4767 4.58301 46.375 13.4813 46.375 24.458C46.375 30.3443 43.8161 35.633 39.75 39.2722M17.2303 30.4596C16.1093 28.7318 15.4583 26.6709 15.4583 24.458C15.4583 18.3599 20.4019 13.4163 26.5 13.4163C32.5981 13.4163 37.5417 18.3599 37.5417 24.458C37.5417 26.6681 36.8923 28.7266 35.774 30.453M26.5 48.7497C24.0607 48.7497 22.0833 46.7723 22.0833 44.333V39.9163C22.0833 37.4771 24.0607 35.4997 26.5 35.4997C28.9393 35.4997 30.9167 37.4771 30.9167 39.9163V44.333C30.9167 46.7723 28.9393 48.7497 26.5 48.7497ZM28.7083 24.458C28.7083 25.6776 27.7196 26.6663 26.5 26.6663C25.2804 26.6663 24.2917 25.6776 24.2917 24.458C24.2917 23.2384 25.2804 22.2497 26.5 22.2497C27.7196 22.2497 28.7083 23.2384 28.7083 24.458Z",
    stroke: "url(#paint0_linear_1356_11195)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1356_11195",
    x1: 6.625,
    y1: 48.7497,
    x2: 46.375,
    y2: 48.7497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.4057f2b342df52f615c03207932a2f8a.svg";
export { ForwardRef as ReactComponent };